"use strict";
exports.__esModule = true;
exports.Question = exports.QuestionKeys = exports.QuestionType = exports.Choices = void 0;
var Choices;
(function (Choices) {
    var AccessibilityRequirements;
    (function (AccessibilityRequirements) {
        AccessibilityRequirements["SightImpaired"] = "sight_impaired";
        AccessibilityRequirements["HearingImpaired"] = "hearing_impaired";
        AccessibilityRequirements["SightAndHearingImpaired"] = "sight_and_hearing_impaired";
        AccessibilityRequirements["None"] = "none";
    })(AccessibilityRequirements = Choices.AccessibilityRequirements || (Choices.AccessibilityRequirements = {}));
    var CarriesMedication;
    (function (CarriesMedication) {
        CarriesMedication["Yes"] = "yes";
        CarriesMedication["No"] = "no";
    })(CarriesMedication = Choices.CarriesMedication || (Choices.CarriesMedication = {}));
    var Gender;
    (function (Gender) {
        Gender["Female"] = "female";
        Gender["Male"] = "male";
    })(Gender = Choices.Gender || (Choices.Gender = {}));
    var IDType;
    (function (IDType) {
        IDType["BirthCertificate"] = "birth_certificate";
        IDType["DniArg"] = "dni_arg";
        IDType["Dni"] = "dni";
        IDType["DriverLicence"] = "driver_licence";
        IDType["ForeignersCard"] = "foreigners_card";
        IDType["MilitaryCard"] = "military_card";
        IDType["NationalPictureId"] = "national_picture_id";
        IDType["SpanishNie"] = "spanish_nie";
        IDType["Passport"] = "passport";
        IDType["TurkishIdentificationNumber"] = "turkish_identification_number";
        IDType["NotTurkishCitizen"] = "not_turkish_citizen";
        /** RUT Identification Number in Chile */
        IDType["RutCHL"] = "rut_chl";
    })(IDType = Choices.IDType || (Choices.IDType = {}));
    var MaritalStatus;
    (function (MaritalStatus) {
        MaritalStatus["Divorced"] = "divorced";
        MaritalStatus["Married"] = "married";
        MaritalStatus["Single"] = "single";
        MaritalStatus["Widowed"] = "widowed";
    })(MaritalStatus = Choices.MaritalStatus || (Choices.MaritalStatus = {}));
    var Meal;
    (function (Meal) {
        Meal["Anything"] = "anything";
        Meal["Meat"] = "meat";
        Meal["Beef"] = "beef";
        Meal["Chicken"] = "chicken";
        Meal["MeatWithoutSalt"] = "meat_without_salt";
        Meal["BeefWithoutSalt"] = "beef_without_salt";
        Meal["ChickenWithoutSalt"] = "chicken_without_salt";
        Meal["Coeliac"] = "coeliac";
        Meal["ChildMeal"] = "child_meal";
        Meal["Pasta"] = "pasta";
        Meal["Snack"] = "snack";
        Meal["Spicy"] = "spicy";
        Meal["Vegetarian"] = "vegetarian";
        Meal["VegetarianSnack"] = "vegetarian_snack";
        Meal["Nothing"] = "nothing";
    })(Meal = Choices.Meal || (Choices.Meal = {}));
    var DiscountTypes;
    (function (DiscountTypes) {
        DiscountTypes["None"] = "none";
        DiscountTypes["Student"] = "student";
        DiscountTypes["StudentWithId"] = "student_with_id";
        DiscountTypes["Teen"] = "teen";
        DiscountTypes["TeenWithId"] = "teen_with_id";
        DiscountTypes["Senior"] = "senior";
        DiscountTypes["SeniorWithId"] = "senior_with_id";
        DiscountTypes["MilitaryActive"] = "military_active";
        DiscountTypes["MilitaryActiveWithId"] = "military_active_with_id";
        DiscountTypes["MilitaryVeteran"] = "military_veteran";
        DiscountTypes["MilitaryVeteranWithId"] = "military_veteran_with_id";
    })(DiscountTypes = Choices.DiscountTypes || (Choices.DiscountTypes = {}));
    var SeatingPreferences;
    (function (SeatingPreferences) {
        /** No seating preferences or none chosen */
        SeatingPreferences["None"] = "none";
        /** Prefers an aisle seat */
        SeatingPreferences["Aisle"] = "aisle";
        /** Prefers a middle seat (when rows of 3 or more) */
        SeatingPreferences["Middle"] = "middle";
        /** Prefers a window seat */
        SeatingPreferences["Window"] = "window";
        /** Prefers a single seat (in a 2+1 configuration) */
        SeatingPreferences["Single"] = "single";
    })(SeatingPreferences = Choices.SeatingPreferences || (Choices.SeatingPreferences = {}));
    var OperatorLoyaltyPrograms;
    (function (OperatorLoyaltyPrograms) {
        /** No loyalty program or none chosen */
        OperatorLoyaltyPrograms["None"] = "none";
        /** Amtrak Guest Rewards */
        OperatorLoyaltyPrograms["Amtrak"] = "amtrak";
        /** VIA Préférence */
        OperatorLoyaltyPrograms["VIA"] = "via";
    })(OperatorLoyaltyPrograms = Choices.OperatorLoyaltyPrograms || (Choices.OperatorLoyaltyPrograms = {}));
    var DocumentForEUBorderEntry;
    (function (DocumentForEUBorderEntry) {
        DocumentForEUBorderEntry["SingleOrDoubleEntryVisa"] = "single_or_double_entry_visa";
        DocumentForEUBorderEntry["MultiEntryVisa"] = "multi_entry_visa";
        DocumentForEUBorderEntry["EUCitizenship"] = "eu_citizenship";
        DocumentForEUBorderEntry["ResidencePermit"] = "eu_residence_permit";
        DocumentForEUBorderEntry["FamilyWithResidenceCard"] = "family_with_residence_card";
        DocumentForEUBorderEntry["LocalBorderPermit"] = "local_border_permit";
        DocumentForEUBorderEntry["LongStayVisa"] = "long_stay_visa";
        DocumentForEUBorderEntry["RefugeeOrPersonInNeed"] = "refugee_or_person_in_need";
        DocumentForEUBorderEntry["DiplomatOrHighRankingOfficial"] = "diplomat_or_high_ranking_official";
    })(DocumentForEUBorderEntry = Choices.DocumentForEUBorderEntry || (Choices.DocumentForEUBorderEntry = {}));
})(Choices = exports.Choices || (exports.Choices = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType["Boolean"] = "boolean";
    QuestionType["Text"] = "text";
    QuestionType["Date"] = "date";
    QuestionType["Selection"] = "selection";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var QuestionKeys;
(function (QuestionKeys) {
    var Meal;
    (function (Meal) {
        Meal["Meal"] = "meal";
        Meal["Breakfast"] = "breakfast";
        Meal["Lunch"] = "lunch";
        Meal["Snack"] = "snack";
        Meal["Supper"] = "supper";
        Meal["Drink"] = "drink";
    })(Meal = QuestionKeys.Meal || (QuestionKeys.Meal = {}));
    var Selection;
    (function (Selection) {
        Selection["AccessibilityRequirements"] = "accessibility_requirements";
        /** Number of bikes the passenger will bring (in total) */
        Selection["NumberOfBikes"] = "number_of_bikes";
        /** Number of bags the passenger will bring (in total) */
        Selection["NumberOfBags"] = "number_of_bags";
        /** Number of extra bags (not including the free bags) */
        Selection["NumberOfExtraBags"] = "number_of_extra_bags";
        Selection["CarriesMedication"] = "carries_medication";
        Selection["Gender"] = "gender";
        Selection["IdType"] = "id_type";
        Selection["MaritalStatus"] = "marital_status";
        Selection["Nationality"] = "nationality";
        Selection["Residency"] = "residency";
        Selection["Discount"] = "discount";
        Selection["SeatingPreference"] = "seating_preference";
        Selection["OperatorLoyaltyProgram"] = "operator_loyalty_program";
        Selection["IdIssuingAuthority"] = "id_issuing_authority";
        /** Airline company - some sources, such as Amstar require passengers to provide an airline company when booking a shuttle */
        Selection["Airline"] = "airline";
        /** Flight number - some sources, such as Amstar require passengers to provide a flight number when booking a shuttle */
        Selection["FlightNumber"] = "flight_number";
        /** The terminal at the airport of origin that the passenger will be picked up from - usually for shuttle services */
        Selection["AirportTerminal"] = "airport_terminal";
        /** Hotel - some sources, such as Amstar require passengers to provide a hotel when booking a shuttle */
        Selection["Hotel"] = "hotel";
        /** On routes entering the EU, some operators might ask for the document for how the passenger will be authorized to enter the EU */
        Selection["DocumentForEUBorderEntry"] = "document_for_eu_border_entry";
    })(Selection = QuestionKeys.Selection || (QuestionKeys.Selection = {}));
    var Text;
    (function (Text) {
        Text["CuilArg"] = "cuil_arg";
        Text["Email"] = "email";
        Text["FirstName"] = "first_name";
        /** @deprecated Use id_type + id_number instead */
        Text["GovernmentId"] = "government_id";
        Text["IdNumber"] = "id_number";
        Text["LastName"] = "last_name";
        Text["PlaceOfBirth"] = "place_of_birth";
        Text["Phone"] = "phone";
        Text["PrimaryContact"] = "primary_contact";
        Text["Profession"] = "profession";
        Text["EmergencyContactName"] = "emergency_contact_name";
        Text["EmergencyContactPhone"] = "emergency_contact_phone";
        Text["TRHESCode"] = "tr_hes_code";
        Text["OperatorLoyaltyProgramNumber"] = "operator_loyalty_program_number";
        /** Common question for border control */
        Text["PurposeOfTravel"] = "purpose_of_travel";
        /** Flight number - some sources require passengers to provide a flight number when booking a shuttle */
        Text["FlightNumber"] = "flight_number";
    })(Text = QuestionKeys.Text || (QuestionKeys.Text = {}));
    var Date;
    (function (Date) {
        Date["Dob"] = "dob";
        Date["IdExpiryDate"] = "id_expiry_date";
    })(Date = QuestionKeys.Date || (QuestionKeys.Date = {}));
    var Boolean;
    (function (Boolean) {
        Boolean["ServiceDog"] = "service_dog";
        Boolean["MobilityAid"] = "mobility_aid";
        Boolean["MotorizedScooter"] = "motorized_scooter";
    })(Boolean = QuestionKeys.Boolean || (QuestionKeys.Boolean = {}));
})(QuestionKeys = exports.QuestionKeys || (exports.QuestionKeys = {}));
function SelectionQuestion(key, values) {
    return {
        key: key,
        choices: values.map(function (value) { return ({ value: value }); }),
        question_type: QuestionType.Selection
    };
}
var Question;
(function (Question) {
    Question.AccessibilityRequirements = SelectionQuestion(QuestionKeys.Selection.AccessibilityRequirements, Object.values(Choices.AccessibilityRequirements));
    Question.CarriesMedication = SelectionQuestion(QuestionKeys.Selection.CarriesMedication, Object.values(Choices.CarriesMedication));
    Question.Gender = SelectionQuestion(QuestionKeys.Selection.Gender, Object.values(Choices.Gender));
    Question.MaritalStatus = SelectionQuestion(QuestionKeys.Selection.MaritalStatus, Object.values(Choices.MaritalStatus));
    Question.Residency = SelectionQuestion(QuestionKeys.Selection.Residency, []);
    Question.Nationality = SelectionQuestion(QuestionKeys.Selection.Nationality, []);
    Question.IdIssuingAuthority = SelectionQuestion(QuestionKeys.Selection.IdIssuingAuthority, []);
    function Meal(key) {
        return SelectionQuestion(key, Object.values(Choices.Meal));
    }
    Question.Meal = Meal;
    Question.Discount = SelectionQuestion(QuestionKeys.Selection.Discount, Object.values(Choices.DiscountTypes));
    function IdType() {
        var choices = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            choices[_i] = arguments[_i];
        }
        choices = choices.length > 0 ? choices : Object.values(Choices.IDType);
        return SelectionQuestion(QuestionKeys.Selection.IdType, choices);
    }
    Question.IdType = IdType;
    function OperatorLoyaltyProgram() {
        var choices = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            choices[_i] = arguments[_i];
        }
        choices =
            choices.length > 0
                ? choices
                : Object.values(Choices.OperatorLoyaltyPrograms);
        return SelectionQuestion(QuestionKeys.Selection.OperatorLoyaltyProgram, choices);
    }
    Question.OperatorLoyaltyProgram = OperatorLoyaltyProgram;
    function SeatingPreference() {
        var choices = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            choices[_i] = arguments[_i];
        }
        choices =
            choices.length > 0
                ? choices
                : Object.values(Choices.SeatingPreferences);
        return SelectionQuestion(QuestionKeys.Selection.SeatingPreference, choices);
    }
    Question.SeatingPreference = SeatingPreference;
    /** Questions where the user is to input a date such as their birthday. */
    Question.Birthday = {
        key: QuestionKeys.Date.Dob,
        question_type: QuestionType.Date
    };
    Question.IdExpiryDate = {
        key: QuestionKeys.Date.IdExpiryDate,
        question_type: QuestionType.Date
    };
    /** Check mark (true/false) questions. */
    Question.ServiceDog = {
        key: QuestionKeys.Boolean.ServiceDog,
        question_type: QuestionType.Boolean
    };
    Question.MobilityAid = {
        key: QuestionKeys.Boolean.MobilityAid,
        question_type: QuestionType.Boolean
    };
    Question.MotorizedScooter = {
        key: QuestionKeys.Boolean.MotorizedScooter,
        question_type: QuestionType.Boolean
    };
})(Question = exports.Question || (exports.Question = {}));
